import {ReactElement, ReactNode} from 'react';
import {Button} from '@/shadcn_components/ui/button';
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuTrigger,
} from '@/shadcn_components/ui/dropdown-menu';
import {ListTodoIcon} from 'lucide-react';
import {Table} from '@tanstack/react-table';
import useDialogState from '@/hooks/useDialogState';
import {ConfirmDialog} from '../refinedev/dialogs/confirm-dialog';

export type BulkActionItemType = {
  icon?: ReactNode;
  title: string;
  // confirm dialog
  confirmTitle?: string;
  confirmContent?: string;
  onConfirm?: () => void;
};

export interface DataTableBulkActionsProps<TData> {
  actions?: BulkActionItemType[];
  className?: string;
  table: Table<TData>;
}

export function DataTableBulkActions<TData>({
  actions,
  table,
  className,
}: DataTableBulkActionsProps<TData>) {
  const confirmDialog = useDialogState();
  if (table.getFilteredSelectedRowModel().rows.length === 0) return null;
  return (
    <>
      <DropdownMenu modal={false}>
        <DropdownMenuTrigger asChild>
          <Button variant="outline" size="sm" className="h-8 lg:flex">
            <ListTodoIcon />
            Hàng loạt ({table.getFilteredSelectedRowModel().rows.length})
          </Button>
        </DropdownMenuTrigger>
        <DropdownMenuContent className={className}>
          {/* <DropdownMenuLabel>Xử lý hàng loạt</DropdownMenuLabel>
        <DropdownMenuSeparator /> */}
          {actions?.map((action, index) => (
            <DropdownMenuItem
              key={index}
              onClick={e => {
                e.preventDefault();
                e.stopPropagation();
                confirmDialog.openDialog({
                  title: action.confirmTitle,
                  content: action.confirmContent,
                  onConfirm: () => {
                    action.onConfirm?.();
                    table.resetRowSelection();
                  },
                });
              }}>
              {action.icon}
              {action.title}
            </DropdownMenuItem>
          ))}
        </DropdownMenuContent>
      </DropdownMenu>
      {confirmDialog.open && (
        <ConfirmDialog
          dialogState={confirmDialog}
          title={confirmDialog?.extraData?.title}
          content={confirmDialog?.extraData?.content}
          onConfirm={confirmDialog?.extraData?.onConfirm}
        />
      )}
    </>
  );
}
